
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteK as ObiOwnShipRemoteKElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-k.js';
 
 
 

 
 export const ObiOwnShipRemoteK = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-k',
   elementClass: ObiOwnShipRemoteKElement,
   events: {
     
   }
  });
 
 